import { MedicineBoxOutlined, CalendarOutlined, FieldNumberOutlined } from '@ant-design/icons';
import { Col, Row, Button } from 'antd';
import { Formik } from 'formik';
import { Form, Input, SubmitButton, Select } from 'formik-antd';
import Wrap from './styles';

type Props = {
  valueSearch: { facility_code: string; facility_name: string; year: string; month: string };
  onSearch: any;
  resetSearch: any;
};

const date = new Date();

const optionYear = [`${date.getFullYear() - 1}`, `${date.getFullYear()}`, `${date.getFullYear() + 1}`];
const optionMonth = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];

const SearchListBilling = ({ valueSearch, onSearch, resetSearch }: Props) => {
  const handleSubmit = async (values: any, form: any) => {
    await onSearch(values);
    form.setSubmitting(false);
  };

  return (
    <Wrap>
      <Formik
        onSubmit={handleSubmit}
        initialValues={valueSearch}
        render={({ resetForm }) => (
          <Form>
            <Row className="detail">
              <Col span={15}>
                <Row>
                  <Col span={13} className="search">
                    <FieldNumberOutlined className="standardBoldFont icon1" />
                    <p className="standardBoldFont">取引先番号</p>
                    <Form.Item name="facility_code">
                      <Input className="input-search" name="facility_code" />
                    </Form.Item>
                  </Col>
                  <Col span={11} className="search">
                    <MedicineBoxOutlined className="icon1" />
                    <p className="standardBoldFont">医療機関名</p>
                    <Form.Item name="facility_name">
                      <Input className="input-search" name="facility_name" />
                    </Form.Item>
                  </Col>
                  <Col span={24} className="search">
                    <CalendarOutlined className="icon1" />
                    <p className="standardBoldFont">請求月</p>
                    <Form.Item name="year">
                      <Select name="year" id="year" style={{ width: '133px' }} size={'large'} placeholder="選択">
                        {optionYear.map((v, i) => (
                          <Select.Option key={i} value={v}>
                            {v}
                          </Select.Option>
                        ))}
                      </Select>
                      <label htmlFor="year"> 年</label>
                    </Form.Item>
                    <Form.Item name="month">
                      <Select name="month" id="month" style={{ width: '81px' }} size={'large'} placeholder="選択">
                        {optionMonth.map((v, i) => (
                          <Select.Option key={i} value={v}>
                            {v}
                          </Select.Option>
                        ))}
                      </Select>
                      <label htmlFor="month"> 月</label>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col span={7} offset={2} className="btn">
                <Button
                  htmlType="reset"
                  onClick={() => {
                    resetForm({
                      values: {
                        facility_code: '',
                        facility_name: '',
                        year: '',
                        month: '',
                      },
                    });
                    resetSearch();
                  }}
                  className="Standard backSetup"
                >
                  リセット
                </Button>
                <SubmitButton className="btnSearch Standard btnDefault">絞り込み表示</SubmitButton>
              </Col>
            </Row>
          </Form>
        )}
      />
    </Wrap>
  );
};

export default SearchListBilling;
